<template>
  <!-- This row is the title -->
  <div class="d-flex h-60 flex-column">
    <div class="loading abcenter" v-if="showOverlay">
      <div class="spinner-grow text-primary abcenter" role="status"></div>
    </div>
    <b-modal id="planwarning" title="LANTERN warning" hide-header-close ok-only>{{ planwarningtext }}</b-modal>
    <b-modal id="notif" title="LANTERN message" hide-header-close ok-only>
      Original plan has been copied. Please paste it at
      <a href="http://tatiyants.com/pev/#/plans/new" target="_blank">here</a>.
    </b-modal>
    <div class="row text-center m-1">
      <div class="col-md-4">
        <span class="thick">SQL query</span>
      </div>
      <div class="col-md-4">
        <span class="thick">Natural language description of QEP</span>
      </div>
      <div class="col-md-4">
        <span class="thick">Visualize Plan</span>
      </div>
    </div>
    <!-- This row is the text boxes -->
    <div class="row flex-fill">
      <div class="col-md-4">
        <textarea v-model="sqltext" class="form-control h-100" placeholder="Enter your query here..."></textarea>
      </div>
      <div class="col-md-4">
        <textarea v-model="plantext" class="form-control form-control-plaintext h-100" readonly></textarea>
      </div>
      <div class="col-md-4" style="position: relative">
        <organization-chart :datasource="ds" :pan="true">
          <template slot-scope="{ nodeData }">
            <div
              v-show="showNode"
              class="title"
              v-bind:style="styleObject"
              style="height:30px; line-height:30px; border-radius:5px;"
              v-tooltip.right = "nodeData.title"
            >
              {{nodeData.name}}
            </div>
          </template>
        </organization-chart>
      </div>
    </div>
    <div class="row text-center m-1">
      <div class="col-md-4">
        <button type="button" class="btn btn-primary" v-on:click="sendSQL()">
          <span v-if="executing" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ submitText }}
        </button>
      </div>
      <div class="col-md-4">
        <!-- <button type="button" class="btn btn-primary mr-1" @click="playPause()" :disabled="!this.planAvailable">{{ playButton }}</button> -->
        <!-- <button type="button" class="btn btn-primary" v-on:click="copy()" :disabled="!this.planAvailable">TreeView</button> -->
        <button type="primary" class="btn btn-primary mr-1" @click="getComparison()" :disabled="!this.neuralAvailable">Compare</Button>
        <b-modal hide-footer scrollable size="xl" v-model="modal1" :trim='true' title="Translation Comparison" >
          <!-- <Comparison/> -->
          <template>
            <code-diff :old-string="oldStr" :new-string="newStr" :file-name="filename" output-format="side-by-side" />
          </template>
        </b-modal>
      </div>
      <div class="col-md-4 h-100">
        <button type="primary" class="btn btn-primary mr-1" @click="modal2 = true" :disabled="!this.planAvailable">Detailed view</Button>
        <b-modal hide-footer scrollable size="xl" v-model="modal2" :trim='true' title="Detailed Tree View" >
          <div >
            <organization-chart :datasource="ds" :pan="true" style="position: relative">
              <template slot-scope="{ nodeData }">
                <div
                  class="title"
                  v-bind:style="styleObject"
                  style="height:30px; line-height:30px; border-radius:5px;"
                  v-tooltip.top-center="nodeData.title"
                >
                  {{nodeData.name}}
                </div>
              </template>
            </organization-chart>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getPlan } from '@/api.js'
import OrganizationChart from 'vue-organization-chart'
import 'vue-organization-chart/dist/orgchart.css'
import { CodeDiff } from 'v-code-diff'

export default {
  components: {
    OrganizationChart,
    CodeDiff
    // modal
  },
  data: function () {
    return {
      sqltext: '',
      showNode: false,
      plantext: '',
      ds: {},
      originalplan: '',
      playing: false,
      pausing: false,
      playButton: 'Play',
      utter: null,
      planwarningtext: '',
      submitText: 'Submit',
      executing: false,
      showOverlay: false,
      modal1: false,
      modal2: false,
      oldStr: "",
      newStr: "",
      filename: 'rule-based :: neural-based',
      styleObject: {
        // height: '30px',
        background: '#006699',
        // color: 'white',
        fontSize: '13px'
      }
    }
  },
  watch: {
    curSql(newVal, oldVal) {
      this.sqlText = newVal
    }
  },
  computed: {
    sqlText: {
      set: function (v) {
        this.sqltext = v
      },
      get: function () {
        return this.sqltext
      }
    },
    ...mapState(['planAvailable', 'curSql', 'neuralAvailable','email','db'])
  },
  methods: {
    setSQL(sql) {
      console.log(this)
    },
    async sendSQL() {
      this.showNode = false
      if (this.sqltext === '') {
        this.planwarningtext = 'You cannot submit empty SQL query!'
        this.$bvModal.show('planwarning')
        return
      }
      this.$store.commit('setPlanAvailability', false)
      this.$store.commit('setNeuralAvailability', false)
      this.plantext = ''
      this.modal1 = false
      // this.$store.commit('setPlanText', '')
      this.submitText = 'Executing...'
      this.executing = true
      this.ds = {}

      this.showOverlay = true
      // send HTTP request
      try {
        let response = await getPlan(this.sqltext, this.db, this.email)
        this.showOverlay = false
        if (response.data['code'] === 'f') {
          this.planwarningtext = response.data['text']
          this.$bvModal.show('planwarning')
        } else {
          this.plantext = response.data['text']
          this.originalplan = response.data['original']
          this.ds = JSON.parse(response.data['tree'])
          this.showNode = true
          this.$store.commit('setPlanAvailability', true)
          if (response.data['flag'] == 0) {
            this.$store.commit('setNeuralAvailability', true)
            this.oldStr = response.data['rule_ans']
            this.newStr = response.data['text']
          }
        }
      } catch (err) {
        this.showOverlay = false
      }

      // restore state after submission
      this.submitText = 'Submit'
      this.executing = false
    },
    getComparison() {
      if (!this.planAvailable) {
        this.planwarningtext = 'Please get the query execution plan first before playing!'
        this.$bvModal.show('planwarning')
        return
      }
      this.modal1 = true
    },
    playPause() {
      if (!this.planAvailable) {
        this.planwarningtext = 'Please get the query execution plan first before playing!'
        this.$bvModal.show('planwarning')
        return
      }
      var synth = window.speechSynthesis
      if (!synth.speaking) {
        this.playing = false
        this.pausing = false
      }
      if (!synth.speaking) {
        // the text hasn't been played yet
        synth.cancel()
        this.utter = new SpeechSynthesisUtterance()
        this.utter.text = this.plantext
        this.utter.onend = this.onPlayEnd
        synth.speak(this.utter)
        this.playButton = 'Pause'
        //this.playing = true;
      } else if (synth.speaking && !synth.paused) {
        // pause playing
        synth.pause()
        this.playButton = 'Play'
        //this.pausing = true;
      } else if (synth.speaking && synth.paused) {
        // resume playing
        synth.resume()
        this.playButton = 'Pause'
        //this.pausing = false;
      }
      //console.log(this.playing);
      //console.log(this.pausing);
    },
    onPlayEnd() {
      this.playButton = 'Play'
      this.playing = false
    },
    async copy() {
      if (!this.planAvailable) {
        this.planwarningtext = "You haven't obtained a plan yet."
        this.$bvModal.show('planwarning')
        return
      }
      try {
        await this.$copyText(this.originalplan)
        this.$bvModal.show('notif')
      } catch (err) {
        this.planwarningtext = 'The original plan cannot be copied.'
        this.$bvModal.show('planwarning')
      }
    }
  }
}
</script>

<style scoped>
.setCenter {
  text-align: center;
}
::v-deep .orgchart-container {
  position     : absolute;
  display      : inline-block;
  height       : 100%;
  width        : calc(100% - 24px);
  border       : 2px dashed #aaa;
  border-radius: 5px;
  overflow     : auto;
  text-align   : center
}
::v-deep .orgchart {
  -webkit-box-sizing   : border-box;
  box-sizing           : border-box;
  display              : inline-block;
  min-height           : 98.7%;
  min-width            : 100%;
  -webkit-touch-callout: none;
  -webkit-user-select  : none;
  -moz-user-select     : none;
  -ms-user-select      : none;
  user-select          : none;
  background-image     : -webkit-gradient(linear, left top, right top, color-stop(10%, rgba(200, 0, 0, .15)), color-stop(10%, transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(10%, rgba(200, 0, 0, .15)), color-stop(10%, transparent));
  background-image     : linear-gradient(90deg, rgba(200, 0, 0, .15) 10%, transparent 0), linear-gradient(rgba(200, 0, 0, .15) 10%, transparent 0);
  background-size      : 10px 10px;
  border               : 1px dashed transparent;
  padding              : 20px
}
</style>
